<template>


  <div>
    <div v-if="isMobile" class="container">
      <div v-if="showIndex" style="display: flex;flex-direction: column;">
         
        <div style="width: 100%;height:40%;display: flex;align-items: center;justify-content: center;">
          <img src="/static/images/astaxin/astaxin.png" class="product-image">
        </div>

        <span style="font-size: 20px;text-align: center;margin-top:20px">Verifiering av produktens äkthet</span>
        <p style="margin-top: 30px;text-align: left;padding:20px 10% 0px 10%;">Ange den 16-siffriga koden du skrapat 
          fram på etiketten för verifiering av
          produktens äkthet</p>
        <div style="margin-bottom: 10px;text-align: center;">
          <input style="width: 60%;padding: 10px 10px 10px 20px;margin-top: 20px;border: 1px solid #ccc;border-radius: 20px;font-size: 16px;" type="text" v-model="antiCode" @input="handleInput" />
        </div>
        <div class="button-group-mobile" style="text-align: center;">
          <button @click="queryData">BEKRÄFTA</button>
        </div>
      </div>




      <div v-if="show300101"  style="display: flex;flex-direction: column;">
         
         <div style="width: 100%;height:40%;display: flex;align-items: center;justify-content: center;">
           <img src="/static/images/astaxin/astaxin.png" class="product-image">
         </div>
 
         <span style="font-size: 20px;padding:0px 8% 0px 20%">Resultat på verifiering</span>
        <p style="font-size:13px;margin-top: 25px;padding:0px 8% 0px 20%">Verifieringsnummer:</p>
        <p style="font-size:13px;padding:0px 8% 0px 20%">{{ this.antiCode }}</p>

        <p style="font-size:13px;margin-top: 12px;padding:0px 8% 0px 20%">Produkten du verifierat är </p>
        <p style="font-size:13px;padding:0px 8% 0px 20%">en äkta Astaxin® produkt. </p>
        <p style="font-size:13px;padding:0px 8% 0px 20%;margin-top: 12px;">Tack för din verifiering av produktens äkthet!</p>
       </div>





       <div v-if="show300102"  style="display: flex;flex-direction: column;">
         
         <div style="width: 100%;height:40%;display: flex;align-items: center;justify-content: center;">
           <img src="/static/images/astaxin/astaxin.png" class="product-image">
         </div>
 
         <span style="font-size: 20px;padding:0px 8% 0px 20%">Resultat på verifiering</span>
        <p style="font-size:13px;margin-top: 25px;padding:0px 8% 0px 20%">Verifieringsnummer:</p>
        <p style="font-size:13px;padding:0px 8% 0px 20%">{{ this.antiCode }}</p>

        <p style="font-size:13px;margin-top: 12px;padding:0px 8% 0px 20%">Produkten du verifierat är </p>
        <p style="font-size:13px;padding:0px 8% 0px 20%">en äkta Astaxin® produkt. </p>

        <p style="font-size:13px;padding:0px 8% 0px 20%;margin-top: 12px;">Detta nummer har verifierats flertalet gånger.</p>
        <p style="font-size:13px;padding:0px 8% 0px 20%;">Vänligen undvik upprepade verifieringar.</p>
        <p style="font-size:13px;padding:0px 8% 0px 20%;margin-top: 12px;">Tack så mycket för att du använder vår service.</p>
       </div>



     

      

      <div v-if="show300106"  style="display: flex;flex-direction: column;">
         
         <div style="width: 100%;height:40%;display: flex;align-items: center;justify-content: center;">
           <img src="/static/images/astaxin/astaxin.png" class="product-image">
         </div>
 
         <span style="font-size: 20px;padding:0px 8% 0px 20%">Resultat på verifiering</span>
        <p style="font-size:13px;margin-top: 25px;padding:0px 8% 0px 20%">Verifieringsnummer:</p>
        <p style="font-size:13px;padding:0px 8% 0px 20%">{{ this.antiCode }}</p>

        <p style="font-size:13px;margin-top: 12px;padding:0px 8% 0px 20%">Informationen du vill verifiera finns inte! </p>
        <p style="font-size:13px;padding:0px 8% 0px 20%">Se upp för förfalskningar eller verifiera igen </p>
        <p style="font-size:13px;padding:0px 8% 0px 20%">och ange rätt nummer.</p>
        <p style="font-size:13px;margin-top: 12px;padding:0px 18% 0px 20%">Tack så mycket för att du använder vår service.</p>
       </div>

    </div>





    <div v-if="!isMobile" class="container">
      <div v-if="showIndex" class="left-section">
        <span style="font-size: 35px;">Verifiering av produktens äkthet</span>
        <p style="margin-top: 60px;">Ange den 16-siffriga koden du skrapat <br />
          fram på etiketten för verifiering av <br />
          produktens äkthet</p>
        <div class="input-group">
          <input type="text" v-model="antiCode" @input="handleInput" />
        </div>
        <div class="button-group">
          <button @click="queryData">BEKRÄFTA</button>
        </div>
      </div>




      <div v-if="show300101" class="left-section">
        <span style="font-size: 35px;">Resultat på verifiering</span>
        <p style="margin-top: 40px;">Verifieringsnummer:</p>
        <p>{{ this.antiCode }}</p>

        <p style="margin-top: 30px;">Produkten du verifierat är </p>
        <p>en äkta Astaxin® produkt.</p>
        <p style="margin-top: 30px;">Tack för din verifiering av produktens äkthet!</p>
      </div>




      <div v-if="show300102" class="left-section">
        <span style="font-size: 35px;">Resultat på verifiering</span>
        <p style="margin-top: 40px;">Verifieringsnummer:</p>
        <p>{{ this.antiCode }}</p>

        <p style="margin-top: 30px;">Produkten du verifierat är </p>
        <p>en äkta Astaxin® produkt. </p>

        <p style="margin-top: 30px;">Detta nummer har verifierats flertalet gånger. </p>
        <p>Vänligen undvik upprepade verifieringar. </p>

        <p style="margin-top: 30px;">Tack så mycket för att du använder vår service.</p>
      </div>

      <div v-if="show300106" class="left-section">
        <span style="font-size: 35px;">Resultat på verifiering</span>
        <p style="margin-top: 40px;">Verifieringsnummer:</p>
        <p>{{ this.antiCode }}</p>

        <p style="margin-top: 30px;">Informationen du vill verifiera finns inte! </p>
        <p>Se upp för förfalskningar eller verifiera igen </p>
        <p>och ange rätt nummer.</p>
        <p style="margin-top: 30px;">Tack så mycket för att du använder vår service.</p>
      </div>
      <div class="right-section">
        <img src="/static/images/astaxin/astaxin.png" class="product-image">
      </div>
    </div>
  </div>
</template>

<!-- 
1234 5678 9012 3456 -->



<style scoped>
.container {
  display: flex;
  width: 100vw;
  height: 100vh;
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
}

.left-section {
  width: 55%;
  display: flex;
  justify-content: center;
  padding-left: 20%;
  flex-direction: column;
}

.right-section {
  width: 45%;
  display: flex;
  align-items: center;
}

.product-image {
  width: 60%;
}

.input-group {
  margin-bottom: 10px;
}

.input-group input {
  width: 47%;
  padding: 10px 10px 10px 20px;
  margin-top: 20px;
  border: 1px solid #ccc;
  border-radius: 20px;
  font-size: 16px;
}

.button-group button {
  width: 47%;
  padding: 10px;
  background-color: #6c2b2b;
  color: white;
  border: none;
  border-radius: 20px;
  font-size: 16px;
  cursor: pointer;
}

.button-group-mobile button {
  width: 60%;
  padding: 10px;
  background-color: #6c2b2b;
  color: white;
  border: none;
  border-radius: 20px;
  font-size: 16px;
  cursor: pointer;
}
.button-group-mobile button:hover {
  background-color: #5a2424;
}


.button-group button:hover {
  background-color: #5a2424;
}
</style>

<script>
import { getAntiData } from '../../api/api'
export default {
  data() {
    return {
      antiCode: "",
      eno:"138712948993",
      showIndex: true,
      isMobile: false,
      show300106: false,
      show300101: false,
      show300102: false,
    }
  },
  mounted() {
    if (this.mobile()) {
      this.isMobile = true;
      // 移动端逻辑
    } else {
      this.isMobile = false
    }
    console.log(this.isMobile)
  },
  methods: {
    mobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    },
    handleInput() {
      this.antiCode = this.antiCode.replace(/(\w{4})(?=\w)/g, '$1 ');
    },
    queryData() {
      const code = this.antiCode.replace(/\s+/g, '');
      if (code == "" || code.length != 16) {
        alert("Ange den 16 siffriga koden mot förfalskning för verifiering av frågor")
        return;
      }
      this.getResult();
    },
    getResult() {
      const code = this.antiCode.replace(/\s+/g, '');
      getAntiData(code, this.eno).then(res => {
        const data = res.data;
        if (data == null || data.code == "500") {
          alert("Undantag för systemfrågor");
        } else {
          if (data.code === "300102") {
            this.show300106 = false
            this.show300101 = false
            this.show300102 = true
            this.showIndex = false
          } else if (data.code == "300101") {
            this.show300106 = false
            this.show300101 = true
            this.show300102 = false
            this.showIndex = false
          } else if (data.code == "300106") {
            this.show300106 = true
            this.show300101 = false
            this.show300102 = false
            this.showIndex = false
          }
        }
      }).catch(err => {
        alert("Undantag för systemfrågor")
      }
      )

    }
  },
  created: function () {
    // const params = this.$route.query;
    // this.eno = params.eno;
    // if (this.eno == "" || this.eno == undefined) {
    //   alert("Använd rätt inmatningsadress för att fråga")
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Astaxin/Index.vue